(($, Drupal) => {
  "use strict";

  Drupal.behaviors.alerts = {
    attach(context) {
      const navbarScrolledMarker = document.getElementById("navbar-scrolled-marker");
      if (!navbarScrolledMarker) {
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              document.body.classList.add("navbar-scrolled");
            } else {
              document.body.classList.remove("navbar-scrolled");
            }
          });
        },
        { threshold: 0 }
      );

      observer.observe(navbarScrolledMarker);
    },
  };
})(jQuery, Drupal);
